import { useMutation, useQuery } from "@tanstack/react-query";
import { OrderRepository } from "./repositories/order-repository";
import { useMessage } from "@/app/messageContext";
import { ClientCreateOrder } from "./types/order";

export const useDeliveryOptions = () => {
  return useQuery({
    queryKey: ["deliveryOptions"],
    queryFn: OrderRepository.fetchOrderOptions,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
};

export const useCreateOrder = () => {
  const messageApi = useMessage();

  return useMutation({
    mutationFn: (order: ClientCreateOrder) =>
      OrderRepository.createOrder(order).then((res) => res.paymentUrl),
    onSuccess: () => { },
    onError: () => {
      messageApi.open({ type: "error", content: "Ошибка. Попробуйте позже." });
    },
  });
};

export const useConfirmOrder = () => {
  const messageApi = useMessage();

  return useMutation({
    mutationFn: OrderRepository.confirmOrder,
    onSuccess: () => {
      messageApi.open({ type: "success", content: "Заказ принят" });
    },
    onError: () => {
      messageApi.open({ type: "error", content: "Ошибка. Попробуйте позже." });
    },
  });
};
